<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4wThuH/images/cover.jpg?1696786155896" alt="This image is the cover for the book Wicked Charlotte, Wicked"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wicked Charlotte, Wicked
      </h1>
      <p class="bookDescription body article font2">
        <p>Bootleggers, swindlers, gold miners and serial killers�Charlotte has courted them all. The Queen City is renowned for its skyline, sports teams and dizzying growth, but just below its smooth, polished exterior lies a dark past full of crime and myriad misdeeds. This second history of Charlotte has been concealed and denied by those who retell the city�s story, and by those who have lived it. Until now. <br/><br/>In Wicked Charlotte, discover the tale of the Chicago gangsters who invaded the city looking to pull a heist to fund sinister maneuverings in their boss�s criminal trial. Learn how a golden nugget found in a nearby creek changed Charlotte from a trading crossroads into a rough and tumble town full of fortune seekers bent on finding a quick dollar and instant riches. And read about the details of the death of one of Charlotte�s most gifted writers, who met his end in a seedy hotel room in Mexico.<br/><br/>This raucous book sheds light on these incidents and many more, revealing a side of Charlotte�s history that few will recognize. The sordid events described here took place on familiar streets and in well known neighborhoods, but rarely have the stories passed beyond the circles of those who lived them. Charlotte has played host to a multitude of villainous characters, and has seen scores of unsavory deeds played out on its shadowy streets. Wicked Charlotte brings it all to the forefront, as never before.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephanie Burt Williams
      </h2>
      
      <p class="authorDescription body article">Stephanie Burt Williams was born and raised in Charlotte, North Carolina, and is a fourth generation Charlottean.  She has worked as a journalist at a number of publications in North and South Carolina and is the author of a book of ghost stories about Charlotte and Mecklenburg County.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2d75398e